import { ArrowTurnRight } from './icons/ArrowTurnRight';
import { Bullhorn } from './icons/Bullhorn';
import { CircleArrowUp } from './icons/CircleArrowUp';
import { CircleDollar } from './icons/CircleDollar';
import { CircleHalfDottedClock } from './icons/CircleHalfDottedClock';
import { CirclePlus } from './icons/CirclePlus';
import { CircleQuestion } from './icons/CircleQuestion';
import { CodeBranch } from './icons/CodeBranch';
import { Envelope } from './icons/Envelope';
import { FileDownload } from './icons/FileDownload';
import { Gear } from './icons/Gear';
import { House } from './icons/House';
import { Message } from './icons/Message';
import { PinTack } from './icons/PinTack';
import { Receipt } from './icons/Receipt';
import { ShareUpRight } from './icons/ShareUpRight';
import { Sitemap } from './icons/Sitemap';
import { Soap } from './icons/Soap';
import { Tasks } from './icons/Tasks';
import { UserPlus } from './icons/UserPlus';
import { Users } from './icons/Users';
import { WindowChartLine } from './icons/WindowChartLine';

type IconName =
    | 'arrowTurnRight'
    | 'bullhorn'
    | 'circleArrowUp'
    | 'circleDollar'
    | 'circleHalfDottedClock'
    | 'circlePlus'
    | 'circleQuestion'
    | 'codeBranch'
    | 'envelope'
    | 'fileDownload'
    | 'gear'
    | 'house'
    | 'message'
    | 'pinTack'
    | 'receipt'
    | 'shareUpRight'
    | 'sitemap'
    | 'soap'
    | 'tasks'
    | 'userPlus'
    | 'users'
    | 'windowChartLine'
    | 'xMark';

const IconMap = new Map<IconName, JSX.Element>([
    ['arrowTurnRight', ArrowTurnRight],
    ['bullhorn', Bullhorn],
    ['circleArrowUp', CircleArrowUp],
    ['circleDollar', CircleDollar],
    ['circleHalfDottedClock', CircleHalfDottedClock],
    ['circlePlus', CirclePlus],
    ['circleQuestion', CircleQuestion],
    ['codeBranch', CodeBranch],
    ['envelope', Envelope],
    ['fileDownload', FileDownload],
    ['gear', Gear],
    ['house', House],
    ['message', Message],
    ['pinTack', PinTack],
    ['receipt', Receipt],
    ['shareUpRight', ShareUpRight],
    ['sitemap', Sitemap],
    ['soap', Soap],
    ['tasks', Tasks],
    ['userPlus', UserPlus],
    ['users', Users],
    ['windowChartLine', WindowChartLine],
]);

export { IconMap };
export type { IconName };
